import styled from 'styled-components';

import { InteractiveTable } from '@dreryk/react-components';

export const StyledEmergencyNotificationSmsConfigurationContactPersonsInteractiveTable = styled(InteractiveTable)`
   width: 520px;
` as typeof InteractiveTable;
